import {
  layout,
  route,
} from '@/util/routes'
import adminRoutes from './admin_routes'

export default () => [
    layout('Default', [
      // Cumuluslog
      route('Dashboard', null, '/', { requiresAuth: true }),
      route('Profile/ProfileEdit', null, 'profile/edit', { requiresAuth: true }),
      route('Profile/ProfilePilotInfoEdit', null, 'profile/pilot-info-edit', { requiresAuth: true }),
      route('Profile/ProfileOrganizationEdit', null, 'profile/organization-edit', { requiresAuth: true, role: 'admin' }),
      route('Profile/ProfileDocuments', null, 'profile/documents', { requiresAuth: true }),
      route('Profile/ProfileTransactions', null, 'profile/transactions', { requiresAuth: true }),
      route('Profile/ProfileActions', null, 'profile/actions', { requiresAuth: true }),
      route('Profile/ProfileChangePassword', null, 'profile/change-password', { requiresAuth: true }),
      route('Profile/ProfileNotifications', null, 'profile/notifications/:id?', { requiresAuth: true }),
      route('Profile/UserTrainingTasks', { default: 'Training/UserTrainingTasks' }, 'profile/training', { requiresAuth: true, can: 'training-edit-student' }),
      route('Documents/Documents', null, 'documents/:sourcetype?/:id?/', { requiresAuth: true }),
      route('FuelOperations/FuelOperations', null, 'fuel-operations/:sourcetype?/:id?/', { requiresAuth: true }),
      route('Logbooks/LogbookGlider', null, 'logbook/glider', { requiresAuth: true }),
      route('Logbooks/LogbookGliderEdit', null, 'logbook/glider/:id', { requiresAuth: true }),
      route('Logbooks/LogbookGeneral', null, 'logbook/general', { requiresAuth: true }),
      route('Logbooks/LogbookGeneralEdit', null, 'logbook/general/:id', { requiresAuth: true }),
      route('Reservations/Reservations', null, 'reservations', { requiresAuth: true }),
      route('Reservations/ReservationsAggregated', null, 'reservations-aggregated', { requiresAuth: true }),
      route('OperatingDays/OperatingDays', null, 'operating-days', { requiresAuth: true }),
      route('Datasources', null, 'datasources', { requiresAuth: true, can: '' }),
      route('AddressBook/AddressBook', null, 'address-book', { requiresAuth: true }),
      ...adminRoutes(),
    ]),

    layout('FullPage', [
      // Időmérő
      route('DailyFlight/Login', { default: 'Login' }, 'daily-flight/login'),
      route('DailyFlight/DailyFlight', { default: 'DailyFlight/DailyFlight' }, 'daily-flight', { requiresAuth: true, can: 'daily-flight-list' }),
      route('DailyFlight/DailyFlightEdit', null, 'daily-flight/:id', { requiresAuth: true, can: 'daily-flight-edit' }),
      route('RFID', { default: 'DailyFlight/DailyFlightEdit' }, 'rfid/:plane_id', { requiresAuth: true }),
      // Notify Teszt
      route('Notify', null, 'notify', { requiresAuth: true, role: 'admin' }),
    ]),

    layout('Page', [
      // Auth
      route('Login', { default: 'Login' }, 'login'),
      route('LoginLang', { default: 'Login' }, 'login/:lang'),
      route('LoginSocial', null, 'login/social'),
      route('Logout', null, 'logout'),
      route('PasswordReminder', null, 'password-reminder'),
      route('ResetPassword', null, 'reset-password/:token'),
      route('Register2', null, 'register'),
      // route('Register2', null, 'register2'),

      // Other
      route('Error', null, 'error/:message'),
      route('Lock', null, 'lock'),
      route('Samples/Pricing', null, 'pricing'),
    ], '/'),
  ]
